import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App.tsx";
import "./index.css";
import { registerServiceWorker } from "./utils/sw-register";

// Global error handler to prevent white-screen crashes
window.addEventListener("error", (e) => {
  console.error("[Global]", e.message);
});
window.addEventListener("unhandledrejection", (e) => {
  console.error("[Global] Unhandled promise rejection");
  e.preventDefault();
});

// Clean up conflicting service workers on startup
registerServiceWorker();

createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
);
